import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from 'app/shared/shared.module';
import { FuseFindByKeyPipeModule } from '@fuse/pipes/find-by-key';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DetailsComponent } from './details/details.component';
import { ListComponent } from './list/list.component';
import { LandingComponent } from './landing.component';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { AppComponent } from 'app/app.component';
import { profilesRoutes } from './landing.routing';
import { FuseCardModule } from '@fuse/components/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import {MatChipsModule} from '@angular/material/chips';
import { QuillModule } from 'ngx-quill';
import { QuoteComponent } from './quote/quote.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AgmCoreModule } from '@agm/core';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ListPortfoliosComponent } from './list-portfolios/list-portfolios.component';
import { FuseMasonryModule } from '@fuse/components/masonry';
import { SwiperModule } from 'swiper/angular';

@NgModule({
  declarations: [
    LandingComponent,
    DetailsComponent,
    ListComponent,
    QuoteComponent,
    ContactUsComponent,
    ListPortfoliosComponent,
  ],
  imports: [
        RouterModule.forChild(profilesRoutes),
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressBarModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatTooltipModule,
        FuseFindByKeyPipeModule,
        MatTabsModule,
        FuseCardModule,
        FuseMasonryModule,
        MatMenuModule,
        MatDividerModule,
        SharedModule,
        MatChipsModule,
        MatStepperModule,
        MatRadioModule,
        MatCheckboxModule,
        MatButtonToggleModule,
        SwiperModule,
        AgmCoreModule.forRoot({
          apiKey: "AIzaSyD-7J2NsMlMODNRFhz-gHIay-YaZXmj4nY&callback",
          libraries: ["places"]
        }),
        QuillModule.forRoot()
  ], 
  // bootstrap: [ AppComponent ]
})
export class ProfilesModule { }
